import
{
    encode
}
from "base64-arraybuffer";
import
{
    Buffer
}
from 'buffer';

import Config from "../Config";

export default class ANPObjectCreator
{
    static getCurrentFileEncoded = () =>
    {
        return new Promise((resolve, reject) =>
        {
            try
            {
                Office.context.document.getFileAsync(
                    "compressed",
                    // { sliceSize: 100000 },
                    function(aResult)
                    {
                        // console.log("aResult", aResult);
                        if (aResult.status === "succeeded")
                        {
                            let aFile = aResult.value;
                            let aDocSlices = [];

                            for (let i = 0; i < aFile.sliceCount; i++)
                            {
                                aFile.getSliceAsync(i, function(aSliceResult)
                                {
                                    if (aSliceResult.status === "succeeded")
                                    {
                                        aDocSlices.push(aSliceResult.value.data);
                                        aFile.closeAsync(function(aCloseResult) {});
                                        getDocData(aDocSlices);
                                    }
                                    else
                                    {
                                        console.warn("getSliceAsync result", aSliceResult);
                                        aFile.closeAsync(function(aCloseResult) {});
                                        resolve(
                                        {
                                            isErr: true,
                                            data: null
                                        });
                                    }
                                });
                            }
                            const getDocData = function(aDocSlices)
                            {
                                let aDocData = [];
                                for (let i = 0; i < aDocSlices.length; i++)
                                {
                                    aDocData = aDocData.concat(aDocSlices[i]);
                                }
                                let sEncoded = encode(aDocData);
                                if (!sEncoded)
                                {
                                    resolve(
                                    {
                                        data: sEncoded,
                                        isErr: true
                                    });
                                }
                                resolve(
                                {
                                    data: sEncoded,
                                    isErr: false
                                });
                            }
                        }
                        else
                        {
                            console.warn("getFileAsync result", aResult);
                            resolve(
                            {
                                isErr: true
                            });
                        }
                    }
                );
            }
            catch (err)
            {
                console.warn(err);
                resolve(
                {
                    isErr: true
                });
            }
        });
    }

    static downloadFileFromEncoded = (sEncoded) =>
    {
        const aReportBuffer = Buffer.from(sEncoded, "base64");
        const aReportFile = new File([aReportBuffer], null);
        const aReportFileUrlObj = URL.createObjectURL(aReportFile);

        let aObjA = document.createElement("a");
        aObjA.style = "display: none";
        aObjA.href = aReportFileUrlObj;
        aObjA.download = Config.sReportNameBase + new Date().getTime() + ".docx";
        document.body.appendChild(aObjA);
        aObjA.click();
    }
}